// These sets are put in a module far far away specifically to be not
// reactive and not touched by Vue. Let them be fast.

// elem => TaskCard component instance
export const taskCardsMap = new Map();

// Set of ElementsPreview component instances
export const elementsPreviewsSet = new Set();
